type FunnelStepLike = { type?: string | null; enabled?: boolean | null };

// The store's rule: a saved but switched-off upsell step shows buyers nothing.
export function getUpsellFunnelStep<Step extends FunnelStepLike>(page: {
  funnelSteps?: readonly Step[] | null;
}): Step | undefined {
  return page.funnelSteps?.find(step => step.enabled && step.type === 'upsell');
}
